var React = require('react');

function Spinner (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"50","cy":"50","r":"32","strokeWidth":"8","stroke":"#a7a7a7","strokeDasharray":"50.26548245743669 50.26548245743669","fill":"none","strokeLinecap":"round","style":{"animationPlayState":"running","animationDelay":"0s"},"transform":"rotate(288.72 50 50)"},React.createElement("animateTransform",{"attributeName":"transform","type":"rotate","repeatCount":"indefinite","dur":"1s","keyTimes":"0;1","values":"0 50 50;360 50 50","style":{"animationPlayState":"running","animationDelay":"0s"}})));
}

Spinner.defaultProps = {"style":{"margin":"auto","background":"none","display":"block","shapeRendering":"auto","animationPlayState":"running","animationDelay":"0s"},"width":"90px","height":"90px","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"};

module.exports = Spinner;

Spinner.default = Spinner;
